<template>
  <q-toolbar v-if="isEnabled" class="text-primary ist-actionbar" v-bind="$attrs">
    <template v-if="slots.start">
      <slot name="start" />
    </template>
    <template v-if="slots.center">
      <slot name="center" />
      <slot />
    </template>
    <template v-if="slots.end">
      <slot name="end" />
    </template>
  </q-toolbar>
  <CuiToolbar class="w-full" v-else v-bind="$attrs">
    <template #default v-if="slots.default">
      <slot />
    </template>
    <template #start v-if="slots.start">
      <slot name="start" />
    </template>
    <template #end v-if="slots.end">
      <slot name="end" />
    </template>
    <template #center v-if="slots.center">
      <slot name="center" />
    </template>
  </CuiToolbar>
</template>

<script setup lang="ts">
import { useSlots } from "vue";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const slots = useSlots();
const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpToolbar");

defineOptions({
  name: "dtpToolbar",
  inheritAttrs: true
});
</script>
